import {
  Box,
  Button,
  Grid,
  Icon,
  MenuItem,
  Paper,
  Select,
  TextField,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { AutoCompleteCliente01 } from '../../forms';

interface IDadosSelect {
  nameBD: string;
  descricao: string;
}

interface IFerramentasDaListagemProps {
  dadosSelecao?: IDadosSelect[];
  dataInicial?: string;
  dataFinal?: string;
  mostrarInputData?: boolean;
  aoMudarDataInicial?: (novoTexto: string) => void;
  aoMudarDataFinal?: (novoTexto: string) => void;
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  aoClicarEmNovo?: () => void;
  mostrarInputBasicSelect?: boolean;
  mostrarAutoComplete?: boolean;
  textoDoSelect?: string;
  aoMudarTextoDoSelect?: (novoTextoselect: string) => void;
  aoMudarTextoDoCliente?: (novoTextoselect: string) => void;
}

export const FerramentasDaListagemVendas: React.FC<IFerramentasDaListagemProps> = ({
  dataInicial = '',
  aoMudarDataInicial,
  dataFinal = '',
  aoMudarDataFinal,
  mostrarInputData = false,
  aoClicarEmNovo,
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
  dadosSelecao = [],
  mostrarInputBasicSelect = false,
  mostrarAutoComplete = false,
  textoDoSelect = '',
  aoMudarTextoDoSelect,
  aoMudarTextoDoCliente,
}) => {
  const partesDaDataInicial = dataInicial.split('/');
  const dataInicialFormatada = partesDaDataInicial.length === 3
    ? `${partesDaDataInicial[2]}-${partesDaDataInicial[1]}-${partesDaDataInicial[0]}`
    : '';

  const partesDaDataFinal = dataFinal.split('/');
  const dataFinalFormatada = partesDaDataFinal.length === 3
    ? `${partesDaDataFinal[2]}-${partesDaDataFinal[1]}-${partesDaDataFinal[0]}`
    : '';

  const handleuuidparceiro = (uuid: string | undefined) => {
    if (uuid != null) {
      aoMudarTextoDoCliente?.(uuid);
    }
  };

  return (
    <Paper sx={{ p: 2, m: 2 }}>
      <Grid container spacing={2} alignItems="center">
        {mostrarInputBasicSelect && (
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <Select
              fullWidth
              size="small"
              value={textoDoSelect}
              onChange={(event) => aoMudarTextoDoSelect?.(event.target.value)}
            >
              {dadosSelecao.map((item) => (
                <MenuItem key={item.nameBD} value={item.nameBD}>
                  {item.descricao}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        )}
        {mostrarAutoComplete && (
          <Grid item xs={12} sm={6} md={4} lg={4}>
              <AutoCompleteCliente01
                uuidcli={handleuuidparceiro}
                isExternalLoading={false}
              />
          </Grid>
        )}
        {mostrarInputData && (
          <>
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Data Inicial"
                  format="DD/MM/YYYY"
                  value={dayjs(dataInicialFormatada)}
                  onChange={(date: Dayjs | null) => {
                    const novoTexto = date ? date.format('DD/MM/YYYY') : '';
                    aoMudarDataInicial?.(novoTexto);
                  }}
                  slotProps={{ textField: { size: 'small', fullWidth: true } }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Data Final"
                  format="DD/MM/YYYY"
                  value={dayjs(dataFinalFormatada)}
                  onChange={(date: Dayjs | null) => {
                    const novoTexto = date ? date.format('DD/MM/YYYY') : '';
                    aoMudarDataFinal?.(novoTexto);
                  }}
                  slotProps={{ textField: { size: 'small', fullWidth: true } }}
                />
              </LocalizationProvider>
            </Grid>
          </>
        )}

        {mostrarBotaoNovo && (
          <Grid item xs={12} sm="auto" display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              endIcon={<Icon>add</Icon>}
              onClick={aoClicarEmNovo}
              sx={{ whiteSpace: 'nowrap' }}
            >
              {textoBotaoNovo}
            </Button>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};
